/**
 * Address autocomplete response parsing (server-proxied Geoapify)
 */

export type AutocompleteSuggestion = {
  formatted: string
  id: string
}

export function buildAutocompleteUrl(query: string, options: { limit?: number } = {}): string {
  const params = new URLSearchParams({ q: query })
  if (options.limit !== undefined) {
    params.set("limit", String(options.limit))
  }
  return `/address_autocomplete?${params.toString()}`
}

export function parseAutocompleteResponse(data: unknown): AutocompleteSuggestion[] {
  if (typeof data !== "object" || data === null) return []
  const root = data as Record<string, unknown>
  if (!Array.isArray(root.suggestions)) return []

  const out: AutocompleteSuggestion[] = []
  for (let i = 0; i < root.suggestions.length; i++) {
    const item = root.suggestions[i]
    if (typeof item !== "object" || item === null) continue
    const record = item as Record<string, unknown>
    const formatted = typeof record.formatted === "string" ? record.formatted.trim() : ""
    if (!formatted) continue
    const id = typeof record.id === "string" && record.id ? record.id : `suggestion-${i}`
    out.push({ formatted, id })
  }
  return out
}
